import { createReducer } from 'redux-act';

import {
  ACTIONS_NAMES_DICT,
  LOGS_ACTIONS as ACTIONS,
} from 'state/actions/logs';

const initialState = {
  data: [],
  loading: false,
  error: null,
  success: false,
  deleted: false,
};

export const logsReducer = createReducer(
  {
    [ACTIONS[ACTIONS_NAMES_DICT.FETCH_DATA_INIT]]: () => ({
      ...initialState,
      loading: true,
    }),
    [ACTIONS[ACTIONS_NAMES_DICT.FETCH_DATA_SUCCESS]]: (state, payload) => ({
      ...state,
      data: payload.data,
      loading: false,
      error: null,
    }),
    [ACTIONS[ACTIONS_NAMES_DICT.FETCH_DATA_FAIL]]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [ACTIONS[ACTIONS_NAMES_DICT.CREATE_ENTITY_INIT]]: (state) => ({
      ...state,
      loading: true,
    }),
    [ACTIONS[ACTIONS_NAMES_DICT.CREATE_ENTITY_SUCCESS]]: (state, payload) => ({
      ...state,
      data: state.data.concat(payload.entity),
      loading: false,
      error: null,
      success: true,
    }),
    [ACTIONS[ACTIONS_NAMES_DICT.CREATE_ENTITY_FAIL]]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [ACTIONS[ACTIONS_NAMES_DICT.CLEAN_UP]]: (state) => ({
      ...state,
      loading: false,
      error: null,
      success: false,
      deleted: false,
    }),
    [ACTIONS[ACTIONS_NAMES_DICT.CLEAR_DATA_LOGOUT]]: () => ({
      ...initialState,
    }),
  },
  initialState
);
